<template>
  <div id="profil" class="pb-2">
    <AppNavbar />

    <div v-if="benutzer && benutzer.funktionen.einstellungen == 1">
      <BenutzerHeader />

      <div v-if="benutzerStatus.deletingUser" class="mt-5">
        <b-spinner variant="primary" type="grow" class="mt-5"></b-spinner>
      </div>

      <b-container v-if="benutzer">
        <b-card border-variant="secondary" no-body>
          <b-card-header header-bg-variant="secondary" class="text-white text-left p-1">
            <h4 class="m-1">
              {{ benutzer.vorname }} {{ benutzer.name }}
              <font-awesome-icon icon="cog" class="float-right grow" v-b-modal.profilBearbeiten />
            </h4>
          </b-card-header>

          <b-row no-gutters>
            <b-col md="5" class="text-center">
              <div
                v-if="benutzerStatus.gettingUserImage || benutzerStatus.uploadingUserImage"
                class="text-center"
              >
                <b-spinner variant="primary" type="grow"></b-spinner>
              </div>
              <div v-else>
                <b-img
                  v-if="benutzerBild"
                  thumbnail
                  fluid
                  :src="`data:${benutzerBild.contentType};base64,${benutzerBild.image}`"
                  alt="Profil Bild"
                  class="mb-3 img-size"
                ></b-img>
                <b-img
                  v-else
                  thumbnail
                  fluid
                  :src="require('../../../assets/profile.png')"
                  alt="file 1"
                ></b-img>
              </div>
            </b-col>
            <b-col md="7">
              <b-card-body>
                <b-card no-body>
                  <b-tabs card>
                    <b-tab title="Benutzer" active>
                      <b-card-text>
                        <b-row>
                          <b-col cols="3">
                            <strong>Geburtstag:</strong>
                          </b-col>
                          <b-col>{{date}}</b-col>
                        </b-row>
                        <hr />
                        <b-row>
                          <b-col cols="3">
                            <strong>Telefon:</strong>
                          </b-col>
                          <b-col>{{benutzer.tel}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Mobil:</strong>
                          </b-col>
                          <b-col>{{benutzer.mobil}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Fax:</strong>
                          </b-col>
                          <b-col>{{benutzer.fax}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>E-Mail:</strong>
                          </b-col>
                          <b-col>{{benutzer.email}}</b-col>
                        </b-row>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Adresse">
                      <b-card-text>
                        <b-row>
                          <b-col cols="3">
                            <strong>Straße:</strong>
                          </b-col>
                          <b-col>{{benutzer.strasse}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>PLZ:</strong>
                          </b-col>
                          <b-col>{{benutzer.plz}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Stadt:</strong>
                          </b-col>
                          <b-col>{{benutzer.ort}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Land:</strong>
                          </b-col>
                          <b-col>{{benutzer.land}}</b-col>
                        </b-row>
                      </b-card-text>
                    </b-tab>
                    <b-tab title="Geschäft">
                      <b-card-text>
                        <b-row>
                          <b-col cols="3">
                            <strong>Telefon:</strong>
                          </b-col>
                          <b-col>{{benutzer.telG}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Mobil:</strong>
                          </b-col>
                          <b-col>{{benutzer.mobilG}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>Fax:</strong>
                          </b-col>
                          <b-col>{{benutzer.faxG}}</b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="3">
                            <strong>E-Mail:</strong>
                          </b-col>
                          <b-col>{{benutzer.emailG}}</b-col>
                        </b-row>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-container>

      <b-container v-else>
        <b-spinner type="grow"></b-spinner>
      </b-container>

      <div class="py-3 mt-3">
        <b-container>
          <b-button variant="link" @click="abmelden()" class="p-0 pr-1">Abmelden</b-button>|
          <a href="https://www.htwsaar.de/impressum-und-datenschutz">Impressum und Datenschutz</a>
        </b-container>
      </div>

      <!-- Profil bearbeiten  Modal -->
      <b-modal
        id="profilBearbeiten"
        title="Profil bearbeiten"
        size="lg"
        header-bg-variant="secondary"
        header-text-variant="white"
        hide-footer
      >
        <div v-if="benutzer">
          <ProfilBearbeiten @profilBearbeitenToast="makeToast" :benutzerDaten="benutzer" />
        </div>
        <b-spinner v-else type="grow"></b-spinner>
      </b-modal>
    </div>

    <b-container v-else class="py-5 headSpace">
      <b-alert variant="danger" class="mt-4" show>Diese Seite steht dir nicht zur Verfügung</b-alert>
    </b-container>
  </div>
</template>

<script>
import AppNavbar from '@/components/Nav/AppNavbar'
import BenutzerHeader from '../Content/BenutzerHeader'
import ProfilBearbeiten from '../Content/ProfilBearbeiten'
import { mapGetters, mapActions } from "vuex";

export default {
  name: "profil",
  components: {
    AppNavbar,
    BenutzerHeader,
    ProfilBearbeiten
  },
  computed: mapGetters(['benutzer', 'benutzerBild', 'benutzerStatus']),
  methods: {
    ...mapActions([
      'updateBenutzer',
      'getBenutzerBild',
      'abmelden'
    ]),
    makeToast(toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: "b-toaster-bottom-full",
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      });
    }
  },
  data() {
    return {
      bild: "",
      date: "",
      file: null
    };
  },
  mounted() {
    this.getBenutzerBild().then(() => {
      this.bild = ` `;
    });

    this.date = new Date(this.benutzer.geburtsdatum);
    this.date =
      ("0" + this.date.getDate()).slice(-2) +
      "." +
      ("0" + (this.date.getMonth() + 1)).slice(-2) +
      "." +
      this.date.getFullYear();
  }
};
</script>


<style scoped>
.img-size {
  max-height: 25em;
}

.headSpace {
  margin-top: 6em;
}
</style>